import { useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import useFiltersState from '../state/useFiltersState';
import { useUserAuth } from '../state/userAuthContext';
import { quoteRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {quoteRoutes.map((prop, key) => {
      if (prop.layout === 'quote') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/tracking-order" to="/tracking-order/main" />
  </Switch>
);

const Quote = () => {
  const { user } = useUserAuth();
  const { setOrdersFilters, setOrdersSearchbarText } = useFiltersState();

  useEffect(() => {
    return () => {
      setOrdersFilters([]);
      setOrdersSearchbarText('');
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <> {user && switchRoutes} </>;
};

export default Quote;
